/*
 * @file: login.js
 * @description: It is Container login screen .
 * @author: navreet
 */
import React, { useEffect, useRef } from 'react'
import Loader from '../../components/Loader'
import './dashboard.css'
import { useDispatch, useSelector } from 'react-redux'
import Box1 from './resizable'
import { LineChart } from '@mui/x-charts/LineChart'
import { BarChart } from '@mui/x-charts/BarChart'
import { dashboardApi, graphApi, graphApiEmission, graphApiPieChart, graphApiUser } from '../../actions/dashboard'
import { useState } from 'react'
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Modal, Grid } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Moment from 'react-moment'
import moment from 'moment'
import GeneralImage from '../../assets/images/cityofglendale.png'
import ChangePassword from '../settings/changePassword'

const { afterToday, allowedMaxDays, combine } = DateRangePicker;

const Dashboard = ({ props, history }) => {
    const dashboarddata = useSelector((state) => state.dashboard)
    const user = useSelector(state => state.user);
    const [filterRedeem, setFilterRedeem] = useState(12);
    const [filterEmission, setFilterEmission] = useState(12);
    const [filterUser, setFilterUser] = useState(12);
    const [dateRangeEmissions, setDateRangeEmissions] = useState(null);
    const [dateRangeUsers, setDateRangeUsers] = useState(null);
    const [dateRangeRedeem, setDateRangeRedeem] = useState(null);

    var unitlist = ["", "K", "M", "G"];
    const formatnumber = (number) => {
        let sign = Math.sign(number);
        let unit = 0;

        while (Math.abs(number) >= 1000) {
            unit = unit + 1;
            number = Math.floor(Math.abs(number) / 100) / 10;
        }
        return sign * Math.abs(number) + unitlist[unit];
    }

    useEffect(() => {
        if (user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin) {
            history.push("/settings")
        }
        if (user && user.data.roles == "merchant" && user.data.last_login_at == 0) {
            history.push("/settings")
        }

    }, [])

    useEffect(() => {
        if (user?.data?.roles === "merchant") {
            const timer = setTimeout(() => {
                history.push("/merchantItems");
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [history, user]);

    const dispatch = useDispatch()

    const sizing = {
        margin: { right: 300 },
        width: 700,
        height: 300,
        // legend: { hidden: true },
    };

    const setDateRange = (data) => {
        setDateRangeEmissions(data);
    }

    useEffect(() => {
        dispatch(
            dashboardApi((res) => { }),
        )
    }, [])

    useEffect(() => {
        setDateRangeEmissions(null);
    }, [filterEmission])
    useEffect(() => {
        setDateRangeUsers(null);
    }, [filterUser])
    useEffect(() => {
        setDateRangeRedeem(null);
    }, [filterRedeem])

    useEffect(() => {
        const params = { filter: filterRedeem }
        if (dateRangeEmissions) {
            params.start_date = moment(dateRangeEmissions[0]).format("MM-DD-YYYY")
            params.end_date = moment(dateRangeEmissions[1]).format("MM-DD-YYYY")
        }
        dispatch(
            graphApiPieChart(params, (res) => {
            }),
        )

    }, [filterEmission, dateRangeEmissions])

    useEffect(() => {
        const params = { filter: filterRedeem }
        if (dateRangeRedeem) {
            params.start_date = moment(dateRangeRedeem[0]).format("MM-DD-YYYY")
            params.end_date = moment(dateRangeRedeem[1]).format("MM-DD-YYYY")
        }
        dispatch(
            graphApi(params, (res) => {
            }),
        )

    }, [filterRedeem, dateRangeRedeem])
    useEffect(() => {
        const params = { filter: filterEmission }
        if (dateRangeEmissions) {
            params.start_date = moment(dateRangeEmissions[0]).format("MM-DD-YYYY")
            params.end_date = moment(dateRangeEmissions[1]).format("MM-DD-YYYY")
        }
        dispatch(
            graphApiEmission(params, (res) => {
            }),
        )

    }, [filterEmission, dateRangeEmissions])
    useEffect(() => {
        const params = { filter: filterUser }
        if (dateRangeUsers) {
            params.start_date = moment(dateRangeUsers[0]).format("MM-DD-YYYY")
            params.end_date = moment(dateRangeUsers[1]).format("MM-DD-YYYY")
        }
        dispatch(
            graphApiUser(params, (res) => {
            }))


    }, [filterUser, dateRangeUsers])

    const loaders = useSelector((state) => state.loader)

    function convertChartDataToCSV(args) {
        let result, columnDelimiter, lineDelimiter, labels, data

        data = args.data.data || null
        if (data == null || !data.length) {
            return null
        }

        labels = args.labels || null
        if (labels == null || !labels.length) {
            return null
        }

        columnDelimiter = args.columnDelimiter || ','
        lineDelimiter = args.lineDelimiter || '\n'
        result = '' + columnDelimiter
        result += labels.join(columnDelimiter)
        result += lineDelimiter

        result += args.data.label.toString()

        for (let i = 0; i < data.length; i++) {
            result += columnDelimiter
            result += data[i]
        }
        result += lineDelimiter

        return result
    }

    function downloadCSV(args) {
        var data, filename, link
        var csv = ''

        var datasets = [
            {
                label: 'User',
                data: dashboarddata && dashboarddata.userGraph.users,

            },
            {
                label: 'Merchant',
                data: dashboarddata && dashboarddata.userGraph.merchant,

            },
        ]

        for (var i = 0; i < datasets.length; i++) {
            csv += convertChartDataToCSV({
                data: datasets[i],
                labels: dashboarddata && dashboarddata.userGraph.months ? dashboarddata.userGraph.months : dashboarddata.userGraph.dates,
            })
        }
        if (csv == null) return

        filename = filterUser + '-Months-User-Merchant.csv'

        if (!csv.match(/^data:text\/csv/i)) {
            csv = 'data:text/csv;charset=utf-8,' + csv
        }

        // not sure if anything below this comment works
        data = encodeURI(csv)
        link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        document.body.appendChild(link) // Required for FF
        link.click()
        document.body.removeChild(link)
    }
    function downloadCSV2(args) {
        var data, filename, link
        var csv = ''
        var datasets = [
            {
                label: 'Hive Points Generated',
                data: dashboarddata && dashboarddata.redeemGraph.earned,

            },
            {
                label: 'Hive Points Redeemed',
                data: dashboarddata && dashboarddata.redeemGraph.redeemed,

            },
        ]

        for (var i = 0; i < datasets.length; i++) {
            csv += convertChartDataToCSV({
                data: datasets[i],
                labels: dashboarddata && dashboarddata.redeemGraph.months ? dashboarddata.redeemGraph.months : dashboarddata.redeemGraph.dates,
            })
        }
        if (csv == null) return

        filename = filterRedeem + '-Months-Hive-Points.csv'
        if (!csv.match(/^data:text\/csv/i)) {
            csv = 'data:text/csv;charset=utf-8,' + csv
        }

        // not sure if anything below this comment works
        data = encodeURI(csv)
        link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        document.body.appendChild(link) // Required for FF
        link.click()
        document.body.removeChild(link)


    }
    function downloadCSV3(args) {
        var data, filename, link
        var csv = ''
        var piedata = [0];
        var pielabel = ["NONE"];
        var piedata = dashboarddata && dashboarddata.pieChart.map((val, index) => {
            return val['value']
        });

        var pielabel = dashboarddata && dashboarddata.pieChart.map((val, index) => {
            return val['label']
        });

        var datasets = [
            {
                label: 'Emission Reduced',
                data: dashboarddata && dashboarddata.emissionGrpah.emission_deduction,

            },
            {
                label: 'Vehicles Emission Reduced',
                data: piedata,

            },

        ]

        for (var i = 0; i < datasets.length; i++) {
            csv += convertChartDataToCSV({
                data: datasets[i],
                labels: i === 0 ? dashboarddata && dashboarddata.emissionGrpah.months ? dashboarddata.emissionGrpah.months : dashboarddata.emissionGrpah.dates : pielabel
            })
        }

        if (csv == null) return

        filename = filterEmission + '-Months-Emission-Reduction.csv'
        if (!csv.match(/^data:text\/csv/i)) {
            csv = 'data:text/csv;charset=utf-8,' + csv
        }

        // not sure if anything below this comment works
        data = encodeURI(csv)
        link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        document.body.appendChild(link) // Required for FF
        link.click()
        document.body.removeChild(link)


    }

    return (

        <div className="dashboard">
            {/* <Loader loading={loaders.isFetching} /> */}
            {user && user.data.roles !== "merchant" ? <>



                <div class="box-container">
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={3}>
                            <div class="box box4">
                                <div className="flext-grid">
                                    <img
                                        className="boximg"
                                        style={{ backgroundColor: 'rgb(216 241 205)' }}
                                        src={require('../../assets/images/513729_earth_element_square_icon.png')}
                                        alt="Views"
                                    />
                                    {/* <svg className='boximg' style={{backgroundColor:"#FCEAEA",color:"red"}}  xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/></svg>
               */}

                                    <div class="text">
                                        <p class="topic">Daily Emission</p>
                                        <p class={Math.sign(dashboarddata?.data?.emissionsGrowthDailyCount) == 1 || 0 ? dashboarddata?.data?.emissionsGrowthDailyCount == "0" ? "topic-heading blue" : "topic-heading green" : dashboarddata?.data?.emissionsGrowthDailyCount == "0" ? "topic-heading blue" : "topic-heading"}>
                                            {' '}
                                            {Math.sign(dashboarddata?.data?.emissionsGrowthDailyCount) == 1 || 0 ?

                                                dashboarddata?.data?.emissionsGrowthDailyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>

                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame 1318 (2).png')}
                                                        alt="Views"
                                                    />
                                                :
                                                dashboarddata?.data?.emissionsGrowthDailyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>
                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame1.png')}
                                                        alt="Views"
                                                    />
                                            }
                                            {' '}
                                            {Math.round(Math.abs(dashboarddata?.data?.emissionGrowthDailyPercentage))}%
                                        </p>
                                    </div>

                                    <div class="text2">
                                        <p class="cuont">{formatnumber(Math.round(dashboarddata?.data?.dailyEmissionCount))}</p>
                                    </div>
                                </div>
                                <div className="flext justify-content-space-between">
                                    {Math.sign(dashboarddata?.data?.emissionsGrowthDailyCount) == 1 || 0 ?
                                        dashboarddata?.data?.emissionsGrowthDailyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img width={124} src={require('../../assets/images/graph1.png')} />
                                        :
                                        dashboarddata?.data?.emissionsGrowthDailyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img
                                                width={124}
                                                src={require('../../assets/images/graph2.png')}
                                                alt="Views"
                                            />
                                    }
                                    <div>
                                        <p className="percenttext">
                                            <span style={{ color: Math.sign(dashboarddata?.data?.emissionsGrowthDailyCount) == 1 || 0 ? dashboarddata?.data?.emissionsGrowthDailyCount == "0" ? "rgb(25, 118, 210)" : '#69A251' : dashboarddata?.data?.emissionsGrowthDailyCount == "0" ? "rgb(25, 118, 210)" : '#ED1B2D', fontWeight: '700' }}>{formatnumber(Math.round(dashboarddata?.data?.emissionsGrowthDailyCount))}</span>{' '}
                                            {Math.sign(dashboarddata?.data?.emissionsGrowthDailyCount) == 1 || 0 ?
                                                "more " :
                                                "less"
                                            }
                                        </p>
                                        <p className="percenttext ">from yesterday</p>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div class="box box4">
                                <div className="flext-grid">
                                    <img
                                        className="boximg"
                                        style={{ backgroundColor: '#D6FEC5' }}
                                        src={require('../../assets/images/10443_earth_globe_world_icon.png')}
                                        alt="Views"
                                    />

                                    <div class="text">
                                        <p class="topic">Weekly Emission</p>
                                        <p class={Math.sign(dashboarddata?.data?.emissionsGrowthWeeklyCount) == 1 || 0 ? dashboarddata?.data?.emissionsGrowthWeeklyCount == "0" ? "topic-heading blue" : "topic-heading green" : dashboarddata?.data?.emissionsGrowthWeeklyCount == "0" ? "topic-heading blue" : "topic-heading"}>

                                            {/* <p class={Math.sign(dashboarddata?.data?.emissionsGrowthWeeklyCount) == 1 || 0 ? "topic-heading green" : "topic-heading"}> */}
                                            {' '}
                                            {Math.sign(dashboarddata?.data?.emissionsGrowthWeeklyCount) == 1 || 0 ?
                                                dashboarddata?.data?.emissionsGrowthWeeklyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>

                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame 1318 (2).png')}
                                                        alt="Views"
                                                    />
                                                :
                                                dashboarddata?.data?.emissionsGrowthWeeklyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>
                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame1.png')}
                                                        alt="Views"
                                                    />
                                            }
                                            {' '}
                                            {Math.round(Math.abs(dashboarddata?.data?.emissionGrowthWeeklyPercentage))}%
                                        </p>
                                    </div>
                                    <div class="text2">
                                        <p class="cuont">{formatnumber(Math.round(dashboarddata?.data?.weeklyEmissionCount))}</p>
                                    </div>
                                </div>
                                <div className="flext justify-content-space-between">
                                    {Math.sign(dashboarddata?.data?.emissionsGrowthWeeklyCount) == 1 || 0 ?
                                        dashboarddata?.data?.emissionsGrowthWeeklyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img width={124} src={require('../../assets/images/graph1.png')} />
                                        :
                                        dashboarddata?.data?.emissionsGrowthWeeklyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img
                                                width={124}
                                                src={require('../../assets/images/graph2.png')}
                                                alt="Views"
                                            />
                                    }
                                    <div>
                                        <p className="percenttext">
                                            <span style={{ color: Math.sign(dashboarddata?.data?.emissionsGrowthWeeklyCount) == 1 || 0 ? dashboarddata?.data?.emissionsGrowthWeeklyCount == "0" ? "rgb(25, 118, 210)" : '#69A251' : dashboarddata?.data?.emissionsGrowthWeeklyCount == "0" ? "rgb(25, 118, 210)" : '#ED1B2D', fontWeight: '700' }}>{formatnumber(Math.round(dashboarddata?.data?.emissionsGrowthWeeklyCount))}</span>{' '}
                                            {Math.sign(dashboarddata?.data?.emissionsGrowthWeeklyCount) == 1 || 0 ?
                                                "more " :
                                                "less"
                                            }
                                        </p>
                                        <p className="percenttext ">from last week</p>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div class="box box1" >
                                <div className="flext-grid">
                                    <img
                                        className="boximg"
                                        src={require('../../assets/images/Icon.png')}
                                        alt="Views"
                                    />
                                    <div class="text">
                                        <p class="topic">Total Users</p>
                                        <p class={Math.sign(dashboarddata?.data?.usersGrowthWeeklyCount) == 1 || 0 ? dashboarddata?.data?.usersGrowthWeeklyCount == "0" ? "topic-heading blue" : "topic-heading green" : dashboarddata?.data?.usersGrowthWeeklyCount == "0" ? "topic-heading blue" : "topic-heading"}>
                                            {/* <p class={Math.sign(dashboarddata?.data?.usersGrowthWeeklyCount) == 1 || 0 ? "topic-heading green" : "topic-heading"}> */}
                                            {' '}
                                            {Math.sign(dashboarddata?.data?.usersGrowthWeeklyCount) == 1 || 0 ?
                                                dashboarddata?.data?.usersGrowthWeeklyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>

                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame 1318 (2).png')}
                                                        alt="Views"
                                                    />
                                                :
                                                dashboarddata?.data?.usersGrowthWeeklyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>
                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame1.png')}
                                                        alt="Views"
                                                    />
                                            }
                                            {' '}
                                            {Math.round(Math.abs(dashboarddata?.data?.usersGrowthWeeklyPercentage))}%
                                        </p>
                                    </div>
                                    <div class="text2">
                                        <p class="cuont">{formatnumber(dashboarddata?.data?.userCount)}</p>
                                    </div>
                                </div>
                                <div className="flext justify-content-space-between">
                                    {Math.sign(dashboarddata?.data?.usersGrowthWeeklyCount) == 1 || 0 ?
                                        dashboarddata?.data?.usersGrowthWeeklyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img width={124} src={require('../../assets/images/graph1.png')} />
                                        :
                                        dashboarddata?.data?.usersGrowthWeeklyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img
                                                width={124}
                                                src={require('../../assets/images/graph2.png')}
                                                alt="Views"
                                            />
                                    }
                                    <div>
                                        <p className="percenttext">
                                            <span style={{ color: Math.sign(dashboarddata?.data?.usersGrowthWeeklyCount) == 1 || 0 ? dashboarddata?.data?.usersGrowthWeeklyCount == "0" ? "rgb(25, 118, 210)" : '#69A251' : dashboarddata?.data?.usersGrowthWeeklyCount == "0" ? "rgb(25, 118, 210)" : '#ED1B2D', fontWeight: '700' }}>{formatnumber(Math.round(dashboarddata?.data?.usersGrowthWeeklyCount))}</span>{' '}
                                            {Math.sign(dashboarddata?.data?.usersGrowthWeeklyCount) == 1 || 0 ?
                                                "more " :
                                                "less"
                                            }
                                        </p>
                                        <p className="percenttext ">from last week</p>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div class="box box3">
                                <div className="flext-grid">
                                    <img
                                        className="boximg"
                                        style={{ backgroundColor: '#FFE7B8' }}
                                        src={require('../../assets/images/dotpoints-02.png')}
                                        alt="Views"
                                    />
                                    <div class="text">
                                        <p class="topic">Total Merchants</p>
                                        <p class={Math.sign(dashboarddata?.data?.merchantsGrowthWeeklyCount) == 1 || 0 ? dashboarddata?.data?.merchantsGrowthWeeklyCount == "0" ? "topic-heading blue" : "topic-heading green" : dashboarddata?.data?.merchantsGrowthWeeklyCount == "0" ? "topic-heading blue" : "topic-heading"}>

                                            {/* <p class={Math.sign(dashboarddata?.data?.merchantsGrowthWeeklyCount) == 1 || 0 ? "topic-heading green" : "topic-heading"}> */}
                                            {' '}
                                            {Math.sign(dashboarddata?.data?.merchantsGrowthWeeklyCount) == 1 || 0 ?
                                                dashboarddata?.data?.merchantsGrowthWeeklyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>

                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame 1318 (2).png')}
                                                        alt="Views"
                                                    />
                                                :
                                                dashboarddata?.data?.merchantsGrowthWeeklyCount == "0" ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#0259ed" d="M256 56c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 168c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" /></svg>
                                                    :
                                                    <img
                                                        src={require('../../assets/images/Frame1.png')}
                                                        alt="Views"
                                                    />
                                            }
                                            {Math.round(Math.abs(dashboarddata?.data?.merchantsGrowthWeeklyPercentage))}%
                                        </p>
                                    </div>
                                    <div class="text2">
                                        <p class="cuont">{formatnumber(dashboarddata?.data?.merchantCount)}</p>
                                    </div>
                                </div>
                                <div className="flext justify-content-space-between">
                                    {Math.sign(dashboarddata?.data?.merchantsGrowthWeeklyCount) == 1 || 0 ?
                                        dashboarddata?.data?.merchantsGrowthWeeklyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img width={124} src={require('../../assets/images/graph1.png')} />
                                        :
                                        dashboarddata?.data?.merchantsGrowthWeeklyCount == 0 ?
                                            <svg height="70" width="124">
                                                <line x1="40" y1="30" x2="400" y2="30" style={{ stroke: "rgb(25, 118, 210)", "strokeWidth": 2 }} />
                                            </svg>
                                            :
                                            <img
                                                width={124}
                                                src={require('../../assets/images/graph2.png')}
                                                alt="Views"
                                            />
                                    }
                                    <div>
                                        <p className="percenttext ">
                                            <span style={{ color: Math.sign(dashboarddata?.data?.merchantsGrowthWeeklyCount) == 1 || 0 ? dashboarddata?.data?.merchantsGrowthWeeklyCount == "0" ? "rgb(25, 118, 210)" : '#69A251' : dashboarddata?.data?.merchantsGrowthWeeklyCount == "0" ? "rgb(25, 118, 210)" : '#ED1B2D', fontWeight: '700' }}>{formatnumber(Math.round(dashboarddata?.data?.merchantsGrowthWeeklyCount))}</span>{' '}
                                            {Math.sign(dashboarddata?.data?.merchantsGrowthWeeklyCount) == 1 || 0 ?
                                                "more " :
                                                "less"
                                            }
                                        </p>
                                        <p className="percenttext ">from last week</p>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className="chart-wrapper">
                    <div className="chart">
                        <div className="chart-header">
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={5}>
                                    <div>
                                        <p className="graph1heading">Emission Reduction</p>
                                        <p className="subheadinggraph">Total emission reduced</p>


                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div>
                                        <DateRangePicker format='dd-MM-yyyy' showOneCalendar onClean={() => setDateRangeEmissions(null)} size="md" onChange={(e) => setDateRangeEmissions(e)} disabledDate={combine(allowedMaxDays(30), afterToday())} placeholder="Select Date Range" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    {!dateRangeEmissions &&
                                        <div style={{ textAlign: 'center', display: 'flex' }}>
                                            <i class=" icons filtericon dateicon">
                                                <img src={require('../../assets/images/calendar-2.png')} />
                                            </i>


                                            <select
                                                className="selectoptiondashboard"
                                                onChange={(e) => setFilterEmission(e.target.value)}
                                                type="select"
                                                disabled={dateRangeEmissions}
                                            >
                                                <option value={3}>3 Months</option>
                                                <option value={6}>6 Months</option>
                                                <option value={9}>9 Months</option>
                                                <option selected value={12}>YTD</option>

                                            </select>

                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <button class="btnDownload" onClick={() => downloadCSV3()}>
                                        <i class="fa fa-download"></i> Download
                                    </button>

                                </Grid>
                            </Grid>
                        </div>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={6} style={{ paddingTop: "52px" }}>
                                <Box1 style={{ display: "flex" }}>

                                    <PieChart
                                        series={[
                                            {
                                                arcLabel: (item) => `${parseFloat(item.value).toFixed(2)}`,
                                                arcLabelMinAngle: 45,
                                                data: dashboarddata && dashboarddata.pieChart ? dashboarddata.pieChart.length != 0 ? dashboarddata.pieChart : [{ value: 100, color: "grey", label: "NONE" }] : [{ value: 100, label: "NONE" }],
                                            },
                                        ]}
                                        // colors={['red', 'blue', 'green']} // Use palette
                                        sx={{
                                            [`& .${pieArcLabelClasses.root}`]: {
                                                fill: 'white',
                                                fontWeight: 'bold',
                                            },
                                        }}
                                        {...sizing}
                                    />
                                </Box1>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <Box1 style={{ display: "flex" }}>

                                    <LineChart
                                        series={[
                                            {
                                                curve: 'linear',
                                                data: dashboarddata && dashboarddata.emissionGrpah && dashboarddata.emissionGrpah.emission_deduction ? dashboarddata.emissionGrpah.emission_deduction : [1000, 3000, 2000, 5000, 4000, 3000, 4000, 3000, 2000, 2000, 5000, 4000,],
                                                // data:  [1000, 3000],

                                                showMark: true,
                                                area: true,
                                                color: '#69A251',
                                                backgroundcolor: 'red',
                                                id: 'feb',
                                            },

                                        ]}
                                        xAxis={[{
                                            scaleType: 'point',
                                            data: dashboarddata && dashboarddata.emissionGrpah && dashboarddata.emissionGrpah.months ? dashboarddata.emissionGrpah.months : dashboarddata.emissionGrpah.dates ? dashboarddata.emissionGrpah.dates : ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
                                            // data:['03-01-2024', '05-01-2024']

                                        }]}
                                        sx={{
                                            '& .MuiLineElement-root': {
                                                strokeWidth: 4,
                                            },
                                            '& .MuiAreaElement-series-jan': {
                                                fill: "url('#myGradient')",
                                            },
                                            '& .MuiAreaElement-series-feb': {
                                                fill: "url('#myGradient6')",
                                            },
                                        }}
                                    >
                                        {' '}
                                        <defs>
                                            <linearGradient id="myGradient" gradientTransform="rotate(50)">
                                                <stop offset="20%" stop-color="#69a2515e" stop-opacity="1" />
                                                <stop offset="80%" stop-color="#6f6c9900" stop-opacity="1" />
                                            </linearGradient>
                                        </defs>
                                        <defs>
                                            <linearGradient id="myGradient6" gradientTransform="rotate(50)">
                                                <stop offset="40%" stop-color="#69a2515e" stop-opacity="1" />
                                                <stop offset="60%" stop-color="#7dc261ad" stop-opacity="1" />
                                            </linearGradient>
                                        </defs>
                                    </LineChart>
                                </Box1>
                            </Grid>
                        </Grid>

                    </div>
                </div>
                <div className="chart-wrapper">
                    <div className="chart">
                        <div className="chart-header">
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} md={2}>
                                    <div>
                                        <p className="graph1heading">User Graphs</p>
                                        <p className="subheadinggraph">Total User Count</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>

                                    <div className="group_icons">
                                        <ul style={{ display: 'flex' }}>
                                            <li className="userList">Users</li>
                                            <li className="vendorList">Merchants</li>

                                        </ul>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>



                                    <div>
                                        <DateRangePicker format='dd-MM-yyyy' showOneCalendar onClean={() => setDateRangeUsers(null)} size="md" onChange={(e) => setDateRangeUsers(e)} disabledDate={combine(allowedMaxDays(30), afterToday())} placeholder="Select Date Range" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>

                                    {!dateRangeUsers &&
                                        <div style={{ textAlign: 'center', display: 'flex' }}>
                                            <i class=" icons filtericon dateicon">
                                                <img src={require('../../assets/images/calendar-2.png')} />
                                            </i>
                                            <select
                                                onChange={(e) => setFilterUser(e.target.value)}
                                                className="selectoptiondashboard"
                                                type="select"
                                            >
                                                <option value={3}>3 Months</option>
                                                <option value={6}>6 Months</option>
                                                <option value={9}>9 Months</option>

                                                <option selected value={12}>YTD</option>
                                            </select>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>

                                    <button onClick={() => downloadCSV()} class="btnDownload">
                                        <i class="fa fa-download"></i> Download
                                    </button>
                                </Grid>
                            </Grid>
                        </div>
                        <Box1>

                            <BarChart
                                series={[
                                    { data: dashboarddata && dashboarddata.userGraph && dashboarddata.userGraph.users ? dashboarddata.userGraph.users : [1000, 3000, 2000, 5000, 4000, 3000, 4000, 3000, 2000, 2000, 5000, 4000,], color: '#442580', id: 'pvId' },
                                    {
                                        data: dashboarddata && dashboarddata.userGraph && dashboarddata.userGraph.merchant ? dashboarddata.userGraph.merchant : [500, 1000, 1000, 3000, 2000, 2500, 1000, 2000, 1500, 1000, 1000, 3000,],
                                        id: 'uvId',
                                        color: '#69A251',
                                        fontSize: '20px',
                                    },
                                ]}

                                skipAnimation={true}
                                height={300}
                                xAxis={[{ data: dashboarddata && dashboarddata.userGraph && dashboarddata.userGraph.months ? dashboarddata.userGraph.months : dashboarddata.userGraph.dates ? dashboarddata.userGraph.dates : ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'], scaleType: 'band' }]}
                            />

                        </Box1>

                        {/* <Chart data={data} axes={axes} /> */}
                    </div>
                </div>

                <div className="chart-wrapper">
                    <div className="chart">
                        <div className="chart-header">
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={5}>
                                    <div>
                                        <p className="graph1heading">Hive Points</p>
                                        <p className="subheadinggraph" style={{ display: 'flex', gap: '32px' }}>
                                            <li style={{ color: 'red' }}>
                                                <span style={{ color: 'black', paddingLeft: '-15px' }}>
                                                    Hive Point Redeemed{' '}
                                                </span>
                                            </li>
                                            <li style={{ color: 'green' }}>
                                                <span style={{ color: 'black', paddingL: '-15px' }}>
                                                    Hive Point Generated{' '}
                                                </span>
                                            </li>
                                        </p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>



                                    <div>
                                        <DateRangePicker format='dd-MM-yyyy' showOneCalendar onClean={() => setDateRangeRedeem(null)} size="md" onChange={(e) => setDateRangeRedeem(e)} disabledDate={combine(allowedMaxDays(30), afterToday())} placeholder="Select Date Range" />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>

                                    {!dateRangeRedeem &&
                                        <div style={{ textAlign: 'center', display: 'flex' }}>
                                            <i class=" icons filtericon dateicon">
                                                <img src={require('../../assets/images/calendar-2.png')} />
                                            </i>
                                            <select
                                                className="selectoptiondashboard"
                                                onChange={(e) => setFilterRedeem(e.target.value)}
                                                type="select"
                                            >
                                                <option value={3}>3 Months</option>
                                                <option value={6}>6 Months</option>
                                                <option value={9}>9 Months</option>

                                                <option selected value={12}>YTD</option>
                                            </select>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>

                                    <button class="btnDownload" onClick={() => downloadCSV2()}>
                                        <i class="fa fa-download"></i> Download
                                    </button>
                                </Grid>
                            </Grid>
                        </div>
                        <Box1>
                            <LineChart
                                series={[
                                    {
                                        curve: 'linear',
                                        data: dashboarddata && dashboarddata.redeemGraph && dashboarddata.redeemGraph.earned ? dashboarddata.redeemGraph.earned : [1000, 3000, 2000, 5000, 4000, 3000, 4000, 3000, 2000, 2000, 5000, 4000,],
                                        showMark: true,
                                        area: true,
                                        color: '#69A251',
                                        backgroundcolor: 'red',
                                        id: 'feb',
                                    },
                                    {
                                        showMark: true,
                                        curve: 'linear',
                                        id: 'jan',
                                        data: dashboarddata && dashboarddata.redeemGraph && dashboarddata.redeemGraph.redeemed ? dashboarddata.redeemGraph.redeemed : [500, 1000, 1000, 3000, 2000, 2500, 1000, 2000, 1500, 1000, 1000, 3000,],
                                        area: true,
                                        color: '#ED1B2D',
                                    },
                                ]}
                                xAxis={[{
                                    scaleType: 'point', data: dashboarddata && dashboarddata.redeemGraph && dashboarddata.redeemGraph.months ? dashboarddata.redeemGraph.months : dashboarddata.redeemGraph.dates ? dashboarddata.redeemGraph.dates : ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
                                }]}
                                sx={{
                                    '& .MuiLineElement-root': {
                                        strokeWidth: 4,
                                    },
                                    '& .MuiAreaElement-series-jan': {
                                        fill: "url('#myGradient')",
                                    },
                                    '& .MuiAreaElement-series-feb': {
                                        fill: "url('#myGradient2')",
                                    },
                                }}
                            >
                                {' '}
                                <defs>
                                    <linearGradient id="myGradient" gradientTransform="rotate(50)">
                                        <stop offset="0%" stop-color="#6f6c993b" stop-opacity="1" />
                                        <stop offset="100%" stop-color="#6f6c9900" stop-opacity="1" />
                                    </linearGradient>
                                </defs>
                                <defs>
                                    <linearGradient id="myGradient2" gradientTransform="rotate(50)">
                                        <stop offset="0%" stop-color="#69a2515e" stop-opacity="1" />
                                        <stop offset="100%" stop-color="#69a25112" stop-opacity="1" />
                                    </linearGradient>
                                </defs>
                            </LineChart>


                        </Box1>
                    </div>
                </div>

            </> :
                <>
                    <div className="progress-bar"></div>
                    <div className="image-container">
                        <img src={GeneralImage} alt="Description of Image" />
                    </div>
                </>
            }
        </div>
    )
}

export default Dashboard
